import React, {useState, useEffect} from "react";
import {Modal} from "components/Modal";
import styled from "styled-components";
import logo from "assets/img/NFLShield.svg";
import logoText from "assets/img/logo-tall-text.svg";
import {useSelector, useDispatch} from "react-redux";
import {RegularButton} from "components/Buttons";
import theme from "assets/css/theme";
import {SSOUtils} from "modules/utils/sso";
import {fetchPrizesPopup} from "modules/actions";
import {SYNDICATE_COUNTRY, IMAGES_URL} from "modules/constants";
import {getPrizesPopupLoading, getPrizesPopupData} from "modules/selectors/prizes_popup";
import {Storage} from "modules/utils/Storage";
import {GameSettingsUtils} from "modules/utils/secret";
import {SponsorLogo} from "components/SponsorLogos";
import {Exist} from "components/Exist";

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	padding: 0 20px 35px;
	gap: 20px;
	overflow: hidden;
	width: 100%;
	button {
		max-width: 250px;
	}
`;

const Inner = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	gap: 16px;
	overflow: auto;
	height: 100%;

	max-width: 310px;
	margin: 0 auto;
`;

const HeaderText = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
`;

const Images = styled.div`
	display: flex;
	gap: 8px;
	flex-wrap: wrap;
	justify-content: center;
	img {
		height: 100px;
		width: auto;
	}
`;
const Logo = styled.img`
	width: 100%;
	max-width: 70px;
	position: absolute;
	left: 50%;
	transform: translateX(-50%) translateY(-50%);
	top: 0;
`;

const Title = styled.div`
	font-size: 14px;
	font-family: "All-ProSans", sans-serif;
	font-weight: 600;
`;

const Text = styled(Title)`
	text-align: center;
	line-height: 19px;
	font-weight: 400;
`;

const LoginButton = styled.button`
	color: ${theme.primary};
	box-shadow: none;
	background: none;
	outline: none;
	border: none;
	font-size: inherit;
	font-family: inherit;
	font-weight: 600;
	cursor: pointer;
`;

export const PrizingModal: React.FC = () => {
	const isLoading = useSelector(getPrizesPopupLoading);
	const prizesPopupData = useSelector(getPrizesPopupData);
	const [openState, changeOpenState] = useState(!Storage.GET("prize_popup"));
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(fetchPrizesPopup(SYNDICATE_COUNTRY.toLowerCase()));
	}, [dispatch]);

	const closeClick = () => {
		Storage.SET("prize_popup", "true");
		changeOpenState(false);
	};

	if (!openState || isLoading || !GameSettingsUtils.IS_ENABLED_SESSION) {
		return null;
	}
	return (
		<Modal
			onClose={closeClick}
			isCloseable={true}
			isCloseOutside={true}
			style={{maxWidth: "500px", paddingTop: "45px", overflow: "visible"}}
		>
			<Wrapper>
				<Logo src={logo} alt={"NFL logo"} />
				<Inner>
					<img src={logoText} alt="" />
					<SponsorLogo />
					<HeaderText>
						<Title>
							{window.getTranslations("prize_modal_title", "Welcome to the Super Bowl Challenge!")}
						</Title>
						<Text>
							{window.getTranslations(
								"prize_modal_body",
								"The NFL Playoff field is now set, so you can make your selections before the games begin to join the competition! "
							)}
						</Text>
					</HeaderText>

					<Exist when={!!prizesPopupData.length}>
						<Images>
							{prizesPopupData
								.filter((item) => item.img?.length)
								.map((item) => (
									<img key={item.id} src={IMAGES_URL + item.img} alt={item.text} />
								))}
						</Images>
					</Exist>

					<RegularButton onClick={closeClick} style={{minHeight: "44px"}}>
						{window.getTranslations("prize_modal_start_button", "Start picking!")}
					</RegularButton>

					<Text>
						{window.getTranslations("prize_modal_not_logged_in", "Have you already made your picks?")}{" "}
						<LoginButton onClick={SSOUtils.OIDC_LOGIN_BUTTON}>
							{window.getTranslations("prize_modal_log_in", "Sign in")}
						</LoginButton>
					</Text>
				</Inner>
			</Wrapper>
		</Modal>
	);
};
